import parse_query_string from 'parse_query_string';
let qs = parse_query_string(window.location.search.substring(1));

export default function(affiliate_params) {
    let siteAffId = 'erogames';
    let aff = qs['aff'] ? decodeURIComponent(qs['aff'].replace(/\+/g, ' ')) : "";
    let nats = qs['ocode'] ? decodeURIComponent(qs['ocode'].replace(/\+/g, ' ')) : "";

    if (!(aff || nats)) {
        aff = process.env.SEXCASH_AFF_ID;
        affiliate_params.forEach(function (param, index) {
            if (qs[param[0]]) {
                // OUR-AFF-ID_TRACKER1_TRACKER2_VISITOR-ID.
                aff = process.env.SEXCASH_AFF_ID + "_" + param[0] + "__" + qs[param[0]];
            }
        });
    }

    let a = document.createElement("script");
    let m = document.getElementsByTagName("script")[0];
    a.async=1;
    a.src="//tracking.sexcash.com/in/track.js?s=" + siteAffId + "&aff="+aff+"&nats="+nats+"&d="+ ((new Date()).getTime())+"&u="+encodeURIComponent(window.location.href.substr(0,4000))+"&r="+encodeURIComponent(document.referrer.substr(0,1000));
    m.parentNode.insertBefore(a,m);
}
